import { render, staticRenderFns } from "./custom-menu-tree.vue?vue&type=template&id=6b47e276&"
import script from "./custom-menu-tree.vue?vue&type=script&lang=js&"
export * from "./custom-menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./custom-menu-tree.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "custom-menu-tree.vue"
export default component.exports